
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import EmptyData from "../body/EmptyData.vue";
import { removeToken, setLoginInfo, settingMethods } from "@/common/cookie";

@Component({
  name: "CalendarTable",
  components: {
    EmptyData,
  },
})
export default class CalendarTable extends Vue {
  @Prop({ type: Array, default: [] }) calendarAndRightList?: any;

  // 当前月
  currMonth = new Date().getMonth() + 1;

  get records() {
    // console.log(111, this.currMonth);
    if (this.calendarAndRightList.length == 0) {
      return [];
    }
    let list = (
      this.calendarAndRightList[this.currMonth - 1].records || []
    ).map((item: any) => {
      // 是否过期
      let currDate = GetCurrentTime();
      item.outOfDate = currDate > item.deadline;
      return item;
    });
    // 排序   有 立即申报 立即自测 的靠前
    list
      .sort((a: any, b: any) => {
        let a1 = a.immediatelyDeclare ? 1 : 0;
        let b1 = b.immediatelyDeclare ? 1 : 0;
        return b1 - a1;
      })
      .sort((a: any, b: any) => {
        let a1 = a.selfTest ? 1 : 0;
        let b1 = b.selfTest ? 1 : 0;
        return b1 - a1;
      });

    // return this.arrayGroup(list, 4)
    return list;
  }

  // @Watch("calendarAndRightList", {immediate: true})
  // handleCityChange() {
  //   console.log(this.calendarAndRightList,111)
  // }

  //  自测工具
  carouselList: Array<any> = [
    [
      {
        icon: require("@/assets/images/icon/home-tool-1.png"),
        title: "高新技术企业认定诊断工具",
        subtitle: "享政策补贴  税收减免",
        url: "/pcm/verify",
        width: 310,
      },
      {
        icon: require("@/assets/images/icon/home-tool-2.png"),
        title: "研发费用加计扣除",
        subtitle: "一键评测  享税收优惠",
        url: "/pcm/productSale",
        width: 310,
      },
      {
        icon: require("@/assets/images/icon/home-tool-3.png"),
        title: "重点软件企业诊断工具",
        subtitle: "精准诊断  享税率优惠",
        url: "/pcm/tax",
        width: 310,
      },
      {
        icon: require("@/assets/images/icon/home-tool-4.png"),
        title: "国高新认证申报",
        subtitle: "",
        url: "/centerform/ChinaHighApply",
        width: 229,
      },
    ],
    [
      {
        icon: require("@/assets/images/icon/home-tool-5.png"),
        title: "研发费用加计扣除申报",
        subtitle: "",
        url: "/centerform/createProject",
        width: 310,
      },
      {
        icon: require("@/assets/images/icon/home-tool-6.png"),
        title: "专精特新申报",
        subtitle: "",
        url: "/centerform/projectapproval",
        width: 310,
      },
    ],
  ];
  //  自测  步骤
  stepsList: Array<any> = [
    {
      icon: require("@/assets/images/icon/home-tool-step-1.png"),
      text: "完善企业信息",
    },
    {
      icon: require("@/assets/images/icon/home-tool-step-2.png"),
      text: "一键匹配政策",
    },
    {
      icon: require("@/assets/images/icon/home-tool-step-3.png"),
      text: "查看扶持政策",
    },
    {
      icon: require("@/assets/images/icon/home-tool-step-4.png"),
      text: "一键匹配",
    },
  ];

  changeMonth(index: number) {
    // (this as any).saveGlobalOperation({type:2,modelType: 7})
    this.currMonth = index;
  }

  // 跳转详情
  toDetail({ id, declareItemId }: any) {
    console.log(id, declareItemId, 210);
    this.$router.push({
      path: "/detail/apply",
      query: {
        projectId: declareItemId,
        directionId: id,
      },
    });
  }

  arrayGroup(array: any, subGroupLength: any) {
    let index = 0;
    let newArray = [];
    while (index < array.length) {
      newArray.push(array.slice(index, (index += subGroupLength)));
    }
    return newArray;
  }

  // 自测工具页
  toolDetail(path: string, toolIndex: number) {
    (this as any).saveGlobalOperation({
      type: 2,
      modelType: toolIndex < 3 ? 4 : 6,
    });

    let vm = this;
    if (!path) {
      return this.$message.warning("暂未开通");
    }
    if (
      path == "/centerform/ChinaHighApply" ||
      path == "/centerform/createProject" ||
      path == "/centerform/projectapproval"
    ) {
      // if (settingMethods == 'develop') {
      //   let initJson = {
      //     authenLevel: '1',
      //     employeeMobile: '134******84',
      //     encodeEmployeeMobile:
      //       '3b68b8e4918c0051f7dd9f58dae4a69c21e2f17d7bc39f45fbb568422b9c61dd9ef58f4ea39e5b3a0599a2dd2dff66ec4d103fad24470f9bc47df4ba0067e9f17d42640bbf409d58f6166780f7479f2d744ba6c2008cc51fccd0d41ced2a66426b646e33895fe3daf12b3b482d8eeee8ae181eacd7a75e005b15f6ce5e174001',
      //     encodeIdNumber:
      //       '918eecad7504d77382e58741f05430b3162532ffb0f2b24713687221ddb0b9992e83f50c0553bc995a625edde27fbfbf85840eab8c3b00298b9c2a5b4c9e33c212c5e3f800c17bbc9bfc0fe2c32456dd88f6e1868760dba4260bce3d5fa1c47f2e43c7ce1c56a1fd91ba92c8fb40883fe8f04424946f6cd1cf2469da3e49b792',
      //     encodeRealName:
      //       '25e6f9e8c33a6c67a4107e96b91f812e5e113cf8670012269891161c540f884d9cb19e4564d0af4ece17ff314453d32a4d719508aa3fc7be854af3723173f1d2d5b83ada42fa1fc46f11dca0f41679d62d2589e06c4bfe7d322acc25aabe482e62cd15d176453cd8389b587669a9ffc4c16d8e254345c2f3a5bb4e3ace257b49',
      //     encodeSocialCreditCode:
      //       '446ccf7d7a1cffeecd6f5f66507fd7298bb62dea88717d5d22ccc7c6daa83668b07aec1246c13f8a8de5da54b332e4eeadb9a06029c1362c792da4b78c17fe42ca140bf78dc5c78c7fad8297f77d93399f37d218ab3814a1b73ec27412be7326a7f1de5793fcfa6042f995c65e92d1c16d5e524ab1c367679eeb246ad423a71c',
      //     idNumber: '5****************2',
      //     realName: '*忠义',
      //     socialCreditCode: '**************957D',
      //     type: 'manager',
      //     uuid: '221653701',
      //   }
      //   localStorage.setItem('setLoginInfo', JSON.stringify(initJson))
      //   let newUrl = vm.$router.resolve(path)
      //   window.open(newUrl.href, '_blank')
      // } else {
      $.ajax({
        type: "get",
        async: false,
        dataType: "jsonp",
        jsonpCallback: "jsonpCallback",
        contentType: "application/json; charset=utf-8",
        url: "https://www.sczwfw.gov.cn/juspace/interface/auth/curMemberCro",
        success: function (result: any) {
          var isLogin = result.success;
          if (isLogin) {
            localStorage.setItem(
              "setLoginInfo",
              JSON.stringify(result.data.curMember)
            );
            let newUrl = vm.$router.resolve(path);
            window.open(newUrl.href, "_blank");
          } else {
            vm.$message("您还未登录,请登录后继续操作");
          }
        },
      });
      function jsonpCallback(resp: any) {
        console.log(resp, 8888);
      }
      // }
    } else {
      vm.$router.push({
        path: path,
        query: {
          areaCode: String(vm.$route.query.areaCode).substring(0, 6),
        },
      });
    }
  }

  // 申办
  immediatelyDeclare(data: any) {
    (this as any).saveGlobalOperation({ type: 2, modelType: 9 });
    this.$emit("immediatelyDeclare", data);
  }

  // 自测
  startTest(data: any) {
    (this as any).saveGlobalOperation({ type: 2, modelType: 8 });
    this.$emit("startTest", data);
  }
}

function GetCurrentTime() {
  let currentTime = "";
  let myDate = new Date();
  let year = myDate.getFullYear();
  let month = parseInt(myDate.getMonth().toString()) + 1; //month是从0开始计数的，因此要 + 1
  let monthValue = "";
  if (month < 10) {
    monthValue = "0" + month.toString();
  } else {
    monthValue = month.toString();
  }
  let day = myDate.getDate();
  let dayValue = "";
  if (day < 10) {
    dayValue = "0" + day.toString();
  } else {
    dayValue = day.toString();
  }

  currentTime = year.toString() + "-" + monthValue + "-" + dayValue; //返回时间的数字组合
  return currentTime;
}
